module.exports = __webpack_public_path__ + "static/assets/f458a864064215d4c1f59bc21ccae5d7.png";